import { Slide } from "react-reveal";

const DigitalMarketingOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't just run campaigns - we build a complete digital
                    marketing systems that attract, convert and retain customers
                    while improving performance over time.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Marketing Strategy & Architecture</h3>
                      <ul>
                        <li>
                          <span>Business & audience review</span>
                        </li>
                        <li>
                          <span>Competitor research & market analysis</span>
                        </li>
                        <li>
                          <span>Full funnel design</span>
                        </li>
                        <li>
                          <span>Channel selection strategy</span>
                        </li>
                        <li>
                          <span>Campaign roadmap & growth plan</span>
                        </li>
                        <li>
                          <span>Brand review & positioning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Search Engine Optimization</h3>
                      <ul>
                        <li>
                          <span>Keyword research & targeting</span>
                        </li>
                        <li>
                          <span>On-page SEO optimization</span>
                        </li>
                        <li>
                          <span>
                            Technical SEO (speed, structure, indexing)
                          </span>
                        </li>
                        <li>
                          <span>Content optimization</span>
                        </li>
                        <li>
                          <span>Link building strategies</span>
                        </li>
                        <li>
                          <span>
                            Google business profile setup & optimization
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Paid Advertising</h3>
                      <ul>
                        <li>
                          <span>Google Ads (Search, Display, Youtube)</span>
                        </li>
                        <li>
                          <span>
                            Social media ads (Facebook, Instagram, tiktok, etc)
                          </span>
                        </li>
                        <li>
                          <span>Audience targeting & segmentation</span>
                        </li>
                        <li>
                          <span>Budget allocation & ROI optimization</span>
                        </li>
                        <li>
                          <span>
                            A/B testing(ads, creatives, landing pages)
                          </span>
                        </li>
                        <li>
                          <span>Video marketing(ads & content)</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Content Marketing & Copywriting</h3>
                      <ul>
                        <li>
                          <span>Website content optimization</span>
                        </li>
                        <li>
                          <span>Landing page copywriting</span>
                        </li>
                        <li>
                          <span>Blog & SEO content strategy</span>
                        </li>
                        <li>
                          <span>Ad creatives & messaging</span>
                        </li>
                        <li>
                          <span>Sales focused storytelling</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Social Marketing & Brand Growth</h3>
                      <ul>
                        <li>
                          <span>Account setup & optimization</span>
                        </li>
                        <li>
                          <span>Content calendars & posting strategy</span>
                        </li>
                        <li>
                          <span>Audience Engagement & growth strategies</span>
                        </li>
                        <li>
                          <span>POS & in-field payment integrations</span>
                        </li>
                        <li>
                          <span>Brand positioning across platforms</span>
                        </li>
                        <li>
                          <span>Influencer & partnerships strategies</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Conversion rate optimization</h3>
                      <ul>
                        <li>
                          <span>Landing page optimization</span>
                        </li>
                        <li>
                          <span>User journey improvements</span>
                        </li>
                        <li>
                          <span>CTA optimization</span>
                        </li>
                        <li>
                          <span>Heatmaps & behaviour analysis</span>
                        </li>
                        <li>
                          <span>Funnel performance improvements</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Analytics, Tracking & Data Systems</h3>
                      <ul>
                        <li>
                          <span>Google analytics setup</span>
                        </li>
                        <li>
                          <span>Conversion & event tracking</span>
                        </li>
                        <li>
                          <span>Campaign performance dashboards</span>
                        </li>
                        <li>
                          <span>User behaviour insights</span>
                        </li>
                        <li>
                          <span>Reporting & actionable insights</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Automation, Retargeting & Lead Nurturing</h3>
                      <ul>
                        <li>
                          <span>Email marketing automation</span>
                        </li>
                        <li>
                          <span>Retargeting campaigns(ads & content)</span>
                        </li>
                        <li>
                          <span>Lead nurturing workflows</span>
                        </li>
                        <li>
                          <span>Customer journey automation</span>
                        </li>
                        <li>
                          <span>CRM integrations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Continous Optimization & Scaling</h3>
                      <ul>
                        <li>
                          <span>Ongoing campaign optimization</span>
                        </li>
                        <li>
                          <span>Performance analysis & improvements</span>
                        </li>
                        <li>
                          <span>Scaling winning campaigns</span>
                        </li>
                        <li>
                          <span>Testing new growth channels</span>
                        </li>
                        <li>
                          <span>Strategy refinements</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalMarketingOffers;
